import { CHANGE_INPUT_RIVERINFO } from "./actionTypes.js";

export function onChangeForm(form, data, name) {
  if (name === "area") {
    form.rivers.disabled = false;
    form.rivers.options = form.rivers.data[data.value];
    form.rivers.value = "";
  } else if (name === "river") {
    form.rivers.value = data.value;
  }

  return { type: CHANGE_INPUT_RIVERINFO, form: form };
}
